module.exports = __webpack_public_path__ + "media/images/nav/icon_1-5c14bf9ecd260f71bc140549de178990.svg";